module.exports = __webpack_public_path__ + "static/media/1.70450f32.jpg";